<template>
  <div>
    <locationnodebasic
      :locationnodes="locationNodes"
      :totalitems="locationNodesLength"
      :isloading="isLoading"
      @locationNodeSaved="initialize()"
    ></locationnodebasic>
  </div>
</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import LocationNodeBasic from "@/components/LocationNodeBasic.vue";

export default {
  components: {
    locationnodebasic: LocationNodeBasic
  },
  watch: {
    
  },
  data() {
    return {
      isLoading: true,
      locationNodesLength: [],
      locationNodes: [],
      page:"",
      limit:""
    };
  },
  computed: {},
  async created() {
    let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/locationNodeBasic'})
      if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
  },

  methods: {
    fetchLocationNodes() {
        this.isLoading=true
      Api()
        .get("/locationNodes/active")
        .then(response => {
          this.locationNodes = response.data;
                this.isLoading=false
        });
    },
   initialize() {
     this.fetchLocationNodes();
    },
  }
};
</script>
